import { render, staticRenderFns } from "./recipient.vue?vue&type=template&id=3c7aaf0b&"
import script from "./recipient.vue?vue&type=script&lang=ts&"
export * from "./recipient.vue?vue&type=script&lang=ts&"
import style0 from "./recipient.vue?vue&type=style&index=0&id=3c7aaf0b&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c7aaf0b')) {
      api.createRecord('3c7aaf0b', component.options)
    } else {
      api.reload('3c7aaf0b', component.options)
    }
    module.hot.accept("./recipient.vue?vue&type=template&id=3c7aaf0b&", function () {
      api.rerender('3c7aaf0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_messages/recipient.vue"
export default component.exports